<div class="d-flex body">
  <router-outlet></router-outlet>
</div>

<t4s-toast-container></t4s-toast-container>